export function parseCitationMarkers(text) {
  const citationPattern = /\[(\d+(?:\s*,\s*\d+)*)\]/g;
  const segments = [];
  let lastIndex = 0;
  let match;
  while ((match = citationPattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ type: 'text', content: text.slice(lastIndex, match.index) });
    }
    const numbers = match[1].split(',').map((s) => parseInt(s.trim(), 10));
    segments.push({ type: 'citations', numbers });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    segments.push({ type: 'text', content: text.slice(lastIndex) });
  }
  return segments;
}

export function stripCitationSeparators(segments) {
  return segments.filter((segment, i) => {
    if (segment.type !== 'text') return true;
    if (!/^[\s,]+$/.test(segment.content)) return true;
    const prev = segments[i - 1];
    const next = segments[i + 1];
    return !prev || !next || prev.type !== 'citations' || next.type !== 'citations';
  });
}
